// مع الموبايل 
import React, { useState, useEffect, useRef } from "react";
import RadiusCircles from "./radiuscircles";
import Logo from "./logo";
import Places from "./places";
import Roads from "./roads";
import Developers from "./developers";
import { useProjectMap } from "../../api/main_Map/useProjectMap";
import SplashScreen from "../splashScreen/splashScreen";
import useMobileTouch from "../masterplan/mopile/useMopileTouch";

function MapComponent({ isRadiusVisible, showPlaces, showRoads, onHideRadius, isOverlayHidden, isDevsActive, setIsDevsActive }) {
  // ================= Constants =================
  const rows = 20;
  const cols = 20;
  const tileSize = 512;
  const mapWidth = cols * tileSize;
  const mapHeight = rows * tileSize;
  const initialCol = 12;
  const initialRow = 15;

  // const pinCoord = [
  //   initialCol * tileSize + tileSize / 2,
  //   initialRow * tileSize + tileSize / 2,
  // ];
  const getMinZoom = () =>
    Math.max(
      window.innerWidth / mapWidth,
      window.innerHeight / mapHeight,
      0.3
    );
  // ================= State =================
  const initialZoom = Math.max(0.2, getMinZoom());
  const [zoom, setZoom] = useState(initialZoom);
  const [pos, setPos] = useState({
    x: window.innerWidth / 2 - initialCol * tileSize * initialZoom,
    y: window.innerHeight / 2 - initialRow * tileSize * initialZoom,
  });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });



  const [velocity, setVelocity] = useState({ x: 0, y: 0 });
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 });
  const developersRef = useRef(null);

  // ================= Refs =================

  const bigCircleRef = useRef(null);


  const mobileTouch = useMobileTouch({
    mapWidth,
    mapHeight,
    zoom,
    setZoom,
    setPos,
    setDragging,
    setVelocity,
    dragging,
    lastPos,
    setLastPos,
    velocity,
    minZoom: getMinZoom(),
    maxZoom: 1.8,
  });
  const handleLogoClick = (e) => {
    e.stopPropagation();
    setIsDevsActive(true);
  };
  // ================= Handlers =================
  const onMouseDown = (e) => {
    if (isOverlayHidden) return; // 🔹 منع التفاعل
    if (isRadiusVisible && bigCircleRef.current) {
      if (!bigCircleRef.current.contains(e.target)) {
        onHideRadius?.();
        return;
      }
    }

    setDragging(true);
    setStart({ x: e.clientX - pos.x, y: e.clientY - pos.y });
  };

  const onMouseMove = (e) => {
    if (isOverlayHidden || !dragging) return; // 🔹 منع التفاعل
    let newX = e.clientX - start.x;
    let newY = e.clientY - start.y;

    const scaledWidth = mapWidth * zoom;
    const scaledHeight = mapHeight * zoom;
    const maxX = 0;
    const maxY = 0;
    const minX =
      scaledWidth < window.innerWidth
        ? window.innerWidth - scaledWidth
        : -scaledWidth + window.innerWidth;
    const minY =
      scaledHeight < window.innerHeight
        ? window.innerHeight - scaledHeight
        : -scaledHeight + window.innerHeight;

    setPos({
      x: Math.max(Math.min(newX, maxX), minX),
      y: Math.max(Math.min(newY, maxY), minY),
    });
  };

  // const onMouseUp = () => setDragging(false);
  const onMouseUp = () => {
    setDragging(false);

    // إجبار إعادة ضبط حالة الماوس
    setTimeout(() => {
      document.body.style.cursor = '';
      document.documentElement.style.cursor = '';
      document.body.style.pointerEvents = 'auto';
    }, 0);
  };

  const onWheel = (e) => {
    if (isOverlayHidden) return; // 🔹 منع التفاعل
    e.preventDefault();

    const scaleAmount = e.deltaY < 0 ? 1.1 : 0.9;
    let newZoom = zoom * scaleAmount;
    const minZoom = getMinZoom();
    newZoom = Math.max(Math.min(newZoom, 1.8), minZoom);

    const rect = e.currentTarget.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const zoomRatio = newZoom / zoom;

    let newX = mouseX - (mouseX - pos.x) * zoomRatio;
    let newY = mouseY - (mouseY - pos.y) * zoomRatio;

    const scaledWidth = mapWidth * newZoom;
    const scaledHeight = mapHeight * newZoom;
    const maxX = 0;
    const maxY = 0;
    const minX =
      scaledWidth < window.innerWidth
        ? window.innerWidth - scaledWidth
        : -scaledWidth + window.innerWidth;
    const minY =
      scaledHeight < window.innerHeight
        ? window.innerHeight - scaledHeight
        : -scaledHeight + window.innerHeight;

    setZoom(newZoom);
    setPos({ x: Math.max(Math.min(newX, maxX), minX), y: Math.max(Math.min(newY, maxY), minY) });
  };

  // ================= Effects =================
  useEffect(() => {
    const handleResize = () => {
      const minZoom = getMinZoom();
      setZoom((z) => Math.max(z, minZoom));
      setPos((p) => {
        const scaledWidth = mapWidth * zoom;
        const scaledHeight = mapHeight * zoom;
        const maxX = 0;
        const maxY = 0;
        const minX =
          scaledWidth < window.innerWidth
            ? window.innerWidth - scaledWidth
            : -scaledWidth + window.innerWidth;
        const minY =
          scaledHeight < window.innerHeight
            ? window.innerHeight - scaledHeight
            : -scaledHeight + window.innerHeight;

        return {
          x: Math.max(Math.min(p.x, maxX), minX),
          y: Math.max(Math.min(p.y, maxY), minY),
        };
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [zoom]);

  // ================= Render =================
  // داخل MapComponent

  const { tiles, loading, projectData } = useProjectMap("sadan");
  const developersSvg = projectData?.developers_svg;

  // 🔹 نحسب هل الـ Places جاهزة فعلاً ولا لأ
  const hasPlacesData = !!(
    projectData?.important_places_svg &&
    projectData?.important_places_details_svg
  );

  // 🔹 نعدل الشرط عشان Places تظهر فقط لو البيانات موجودة واليوزر فعّلها
  const shouldShowPlaces = showPlaces && hasPlacesData && !isOverlayHidden;


  // ================= State للأماكن المهمة (Landmarks/Places) =================
  const [hoveredPlace, setHoveredPlace] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState(null);

  // دالة التحكم في hover و click على الأماكن
  const handlePlaceInteraction = ({ id, center, action }) => {
    if (action === "hover") {
      if (id === null) {
        setHoveredPlace(null);
      } else {
        setHoveredPlace(id);
      }
    } else if (action === "click" && id) {
      setSelectedPlace((prev) => {
        if (prev?.id === id) {
          return null;
        } else {
          return { id, center };
        }
      });
    }
  };

  return (
    <div
      id="map-container"
      style={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
        cursor: isOverlayHidden ? "default" : dragging ? "grabbing" : "grab",
        pointerEvents: isOverlayHidden ? "none" : "auto",
        touchAction: "none",
        WebkitUserSelect: "none",
      }}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      onWheel={onWheel}
      onTouchStart={(e) => {
        if (!isOverlayHidden) mobileTouch.onTouchStart(e);
      }}
      onTouchMove={isOverlayHidden ? undefined : mobileTouch.onTouchMove}
      onTouchEnd={isOverlayHidden ? undefined : mobileTouch.onTouchEnd}
      onTouchCancel={isOverlayHidden ? undefined : mobileTouch.onTouchCancel}
    >
      {/* الـ Tiles + كل الطبقات اللي جواها (مع الـ transform) */}
      <div
        style={{
          position: "absolute",
          left: pos.x,
          top: pos.y,
          width: mapWidth,
          height: mapHeight,
          transform: `scale(${zoom})`,
          transformOrigin: "top left",
          userSelect: "none",
        }}
      >

        {/* 1. الـ Tiles تحت خالص */}
        {Array.from({ length: rows }).map((_, rowIdx) =>
          Array.from({ length: cols }).map((_, colIdx) => {
            const tileSrc = tiles.find((t) =>
              t.includes(`tile_${colIdx}_${rowIdx}.png`)
            );

            return (
              <img
                key={`${colIdx}-${rowIdx}`}
                src={tileSrc ? `https://api.gravity-proptech.com/public/storage/${tileSrc}` : ""}
                alt={`tile ${colIdx},${rowIdx}`}
                width={tileSize}
                height={tileSize}
                draggable={false}
                style={{
                  position: "absolute",
                  left: colIdx * tileSize,
                  top: rowIdx * tileSize,
                  imageRendering: "pixelated",
                  border: "none",
                  margin: 0,
                  padding: 0,
                  display: "block",
                  width: `${tileSize + 5}px`,
                  height: `${tileSize + 5}px`,
                }}
              />
            );
          })
        )}

        {/* 2. الـ Roads فوق الـ Tiles */}
        {showRoads && (
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: mapWidth,
              height: mapHeight,
              pointerEvents: "none", // عشان ما يعطلش الكليك على Places أو Logo
            }}
          >
            <Roads />
          </div>
        )}

        {/* 3. الـ Places فوق الـ Roads */}
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: mapWidth,
            height: mapHeight,
            pointerEvents: "none",
          }}
        >
          <Places
            mapWidth={mapWidth}
            mapHeight={mapHeight}
            showPlaces={shouldShowPlaces}
            important_places_svg={projectData?.important_places_svg}
            important_places_details_svg={projectData?.important_places_details_svg}
            hoveredPlace={hoveredPlace}
            selectedPlace={selectedPlace}
            onPlaceClick={handlePlaceInteraction}
          />

        </div>

        {/* 4. الـ Logo فوق الـ Places */}
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: mapWidth,
            height: mapHeight,
            pointerEvents: "none",
            zIndex: 1000,

          }}
        >
          {!isDevsActive ? (
            <Logo
              mapWidth={mapWidth}
              mapHeight={mapHeight}
              onLogoClick={handleLogoClick}
            />
          ) : (
            <Developers
              ref={developersRef}
              mapWidth={mapWidth}
              mapHeight={mapHeight}
              developersSvg={projectData?.developers_svg}
              style={{ pointerEvents: 'auto' }}
            />

          )}
        </div>
        {isRadiusVisible && (
          <RadiusCircles
            isVisible={true}
            onHideRadius={onHideRadius}
            mapWidth={mapWidth}
            mapHeight={mapHeight}
          />
        )}
      </div>

      {/* Splash Screen */}
      {loading && <SplashScreen />}
    </div>
  );
}

export default MapComponent;